<template>
  <loading v-if="loading"/>
</template>

<script>
import { AuthService } from "@/services/auth.service"
import { getMerchanIDCurrent } from '@/utils/auth'
export default {
  name: 'logout',
  data() {
    return {
      loading: true
    }
  },

  async created() {
    await this.logout()
  },

  methods: {
    async logout() {
      const merchantId = getMerchanIDCurrent()
      if(merchantId != '' && merchantId != null && merchantId != undefined){
        localStorage.removeItem('locationName')
        await AuthService.packageBackHome()
      }else{
        window.open(`${process.env.VUE_APP_URL}/homepage`, '_parent')
      }
		}
  }
}
</script>